// document.addEventListener("DOMContentLoaded", function () {
//   const stickyCartIsland = document.getElementById("sticky-cart-island");
//   const originalForm = document.querySelector(
//     "#ProductForm-" + document.querySelector("[data-section]").dataset.section
//   );
//   const originalQuantityInput = document.querySelector(
//     '.product-selector__quantity input[type="number"], .product-selector__quantity input[name="quantity"]'
//   );
//   const originalAddToCartBtn = document.querySelector(
//     ".product-selector__submit"
//   );

//   if (!stickyCartIsland || !originalForm || !originalAddToCartBtn) return;

//   // Get sticky island elements
//   const stickyQuantityInput = stickyCartIsland.querySelector(".quantity-input");
//   const stickyIncreaseBtn =
//     stickyCartIsland.querySelector(".quantity-increase");
//   const stickyDecreaseBtn =
//     stickyCartIsland.querySelector(".quantity-decrease");
//   const stickyAddToCartBtn = stickyCartIsland.querySelector(
//     "#sticky-add-to-cart"
//   );

//   // Sync quantity between original and sticky forms
//   function syncQuantity(source, target) {
//     if (source && target) {
//       target.value = source.value;
//     }
//   }

//   // Update quantity in sticky island
//   function updateStickyQuantity(newValue) {
//     if (stickyQuantityInput) {
//       stickyQuantityInput.value = Math.max(1, parseInt(newValue) || 1);
//       if (originalQuantityInput) {
//         originalQuantityInput.value = stickyQuantityInput.value;
//         // Trigger change event on original input
//         originalQuantityInput.dispatchEvent(
//           new Event("change", { bubbles: true })
//         );
//       }
//     }
//   }

//   // Sticky island quantity controls
//   if (stickyIncreaseBtn) {
//     stickyIncreaseBtn.addEventListener("click", function () {
//       const currentValue = parseInt(stickyQuantityInput.value) || 1;
//       updateStickyQuantity(currentValue + 1);
//     });
//   }

//   if (stickyDecreaseBtn) {
//     stickyDecreaseBtn.addEventListener("click", function () {
//       const currentValue = parseInt(stickyQuantityInput.value) || 1;
//       if (currentValue > 1) {
//         updateStickyQuantity(currentValue - 1);
//       }
//     });
//   }

//   if (stickyQuantityInput) {
//     stickyQuantityInput.addEventListener("change", function () {
//       updateStickyQuantity(this.value);
//     });
//   }

//   // Sync from original to sticky when original changes
//   if (originalQuantityInput) {
//     originalQuantityInput.addEventListener("change", function () {
//       syncQuantity(this, stickyQuantityInput);
//     });
//   }

//   // Sticky add to cart functionality
//   if (stickyAddToCartBtn) {
//     stickyAddToCartBtn.addEventListener("click", function () {
//       // Sync quantities before submitting
//       if (originalQuantityInput && stickyQuantityInput) {
//         originalQuantityInput.value = stickyQuantityInput.value;
//       }

//       // Trigger the original add to cart button
//       if (originalAddToCartBtn) {
//         originalAddToCartBtn.click();
//       }
//     });
//   }

//   // Show/hide sticky island based on scroll position
//   function toggleStickyIsland() {
//     if (!originalAddToCartBtn) return;

//     const originalRect = originalAddToCartBtn.getBoundingClientRect();
//     const isOriginalVisible =
//       originalRect.top >= 0 && originalRect.bottom <= window.innerHeight;

//     if (isOriginalVisible) {
//       stickyCartIsland.classList.remove("visible");
//     } else {
//       stickyCartIsland.classList.add("visible");
//     }
//   }

//   // Listen for scroll events
//   let scrollTimeout;
//   window.addEventListener("scroll", function () {
//     clearTimeout(scrollTimeout);
//     scrollTimeout = setTimeout(toggleStickyIsland, 10);
//   });

//   // Listen for resize events
//   window.addEventListener("resize", toggleStickyIsland);

//   // Initial check
//   setTimeout(toggleStickyIsland, 100);

//   // Update sticky cart button state based on product availability
//   function updateStickyButtonState() {
//     if (!originalAddToCartBtn || !stickyAddToCartBtn) return;

//     const isDisabled = originalAddToCartBtn.disabled;
//     const buttonText =
//       originalAddToCartBtn.textContent ||
//       originalAddToCartBtn.value ||
//       "Add to Cart";

//     stickyAddToCartBtn.disabled = isDisabled;
//     stickyAddToCartBtn.textContent = buttonText;
//   }

//   // Watching for changes in the original button
//   if (originalAddToCartBtn) {
//     const observer = new MutationObserver(updateStickyButtonState);
//     observer.observe(originalAddToCartBtn, {
//       attributes: true,
//       childList: true,
//       subtree: true,
//     });

//     updateStickyButtonState();
//   }
// });




document.addEventListener('DOMContentLoaded', function() {
  const stickyCartIsland = document.getElementById('sticky-cart-island');
  const originalForm = document.querySelector('#ProductForm-' + document.querySelector('[data-section]').dataset.section);
  const originalQuantityInput = document.querySelector('.product-selector__quantity input[type="number"], .product-selector__quantity input[name="quantity"]');
  const originalAddToCartBtn = document.querySelector('.product-selector__submit');
  
  if (!stickyCartIsland || !originalForm || !originalAddToCartBtn) return;

  const HIDE_DELAY = 600; 
  let hideTimeout;

  const stickyQuantityInput = stickyCartIsland.querySelector('.quantity-input');
  const stickyIncreaseBtn = stickyCartIsland.querySelector('.quantity-increase');
  const stickyDecreaseBtn = stickyCartIsland.querySelector('.quantity-decrease');
  const stickyAddToCartBtn = stickyCartIsland.querySelector('#sticky-add-to-cart');

  // Variant data lives in the product-selector JSON script, so the sticky price
  // stays in sync with the theme instead of duplicating variant prices.
  const variants = (function () {
    const json = document.querySelector('product-selector [type="application/json"]');
    if (!json) return [];
    try {
      return JSON.parse(json.textContent) || [];
    } catch (e) {
      return [];
    }
  })();

  function getUnitPrice() {
    const variantInput = originalForm.querySelector('[name="id"]');
    const variantId = variantInput ? parseInt(variantInput.value, 10) : NaN;
    const variant = variants.find(v => v.id === variantId);

    if (variant && typeof variant.price === 'number') return variant.price;
    return parseInt(stickyAddToCartBtn?.dataset.unitPrice, 10) || 0;
  }

  function getTotalPrice() {
    const unitPrice = getUnitPrice();
    if (!unitPrice) return '';

    const quantity = Math.max(1, parseInt(stickyQuantityInput?.value, 10) || 1);
    const total = unitPrice * quantity;
    const moneyFormat = window.theme?.settings?.money_with_currency_format;

    return typeof formatPrice === 'function' && moneyFormat
      ? formatPrice(moneyFormat, total / 100)
      : (total / 100).toFixed(2);
  }

  // The source button's label already carries a price ("Add to cart - $64.00"),
  // so drop any trailing amounts before appending the quantity-aware total.
  const TRAILING_PRICE = /\s*[-\u2013\u2014\u00b7|]\s*\S*[\d.,]+\S*\s*$/;

  function stripPrice(label) {
    let stripped = label.trim();
    let previous;
    do {
      previous = stripped;
      stripped = stripped.replace(TRAILING_PRICE, '').trim();
    } while (stripped !== previous && stripped);
    return stripped || previous;
  }

  // The theme renders the in-button price as its own span (snippets/button.liquid),
  // shown only under 749px via `product-form .btn-price`. Update that span in place
  // rather than the button's textContent, which would destroy it.
  function decoratePriceSpan(button) {
    if (!button) return;

    const total = getTotalPrice();
    if (!total) return;

    let priceSpan = button.querySelector('.btn-price');
    if (!priceSpan) {
      // toggleAddButton() rewrites textContent on variant change, dropping the span
      priceSpan = document.createElement('span');
      priceSpan.className = 'btn-price';
      button.appendChild(priceSpan);
    }

    const next = `- ${total}`;
    if (priceSpan.textContent.trim() !== next) priceSpan.textContent = next;
  }

  // The sticky island button is hand-written markup with no price span, so it
  // carries the total in its label instead. Writes only when the text differs so
  // the MutationObserver watching the source button cannot feed itself.
  function decorateStickyButton() {
    if (!stickyAddToCartBtn || !originalAddToCartBtn) return;

    const label = stripPrice(originalAddToCartBtn.textContent || originalAddToCartBtn.value || 'Add to Cart');
    const total = getTotalPrice();

    stickyAddToCartBtn.disabled = originalAddToCartBtn.disabled;

    const next = total && !originalAddToCartBtn.disabled ? `${label} - ${total}` : label;
    if (stickyAddToCartBtn.textContent.trim() !== next) stickyAddToCartBtn.textContent = next;
  }

  // The in-page button is the only add-to-cart on mobile - both sticky bars are
  // display:none under 768px - so it needs the price span kept in sync too.
  function renderAddToCartButtons() {
    if (!originalAddToCartBtn) return;

    decoratePriceSpan(originalAddToCartBtn);
    decoratePriceSpan(document.querySelector('.product-bar__submit'));
    decorateStickyButton();
  }

  function isMobile() {
    return window.innerWidth <= 767;
  }

  // Hide sticky island with delay (for cart drawer)
  function hideStickyIslandForCartDrawer() {
    if (isMobile()) return; 
    
    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(() => {
      stickyCartIsland.classList.remove('visible');
    }, HIDE_DELAY);
  }

  function showStickyIslandFromCartDrawer() {
    if (isMobile()) return; 
    
    clearTimeout(hideTimeout);
    const originalRect = originalAddToCartBtn.getBoundingClientRect();
    const isOriginalVisible = originalRect.top >= 0 && originalRect.bottom <= window.innerHeight;
    
    if (!isOriginalVisible) {
      stickyCartIsland.classList.add('visible');
    }
  }

  // Sync quantity between original and sticky forms
  function syncQuantity(source, target) {
    if (source && target) {
      target.value = source.value;
    }
  }

  function updateStickyQuantity(newValue) {
    if (stickyQuantityInput) {
      stickyQuantityInput.value = Math.max(1, parseInt(newValue) || 1);
      if (originalQuantityInput) {
        originalQuantityInput.value = stickyQuantityInput.value;
        originalQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      renderAddToCartButtons();
    }
  }

  // Sticky island quantity controls
  if (stickyIncreaseBtn) {
    stickyIncreaseBtn.addEventListener('click', function() {
      const currentValue = parseInt(stickyQuantityInput.value) || 1;
      updateStickyQuantity(currentValue + 1);
    });
  }

  if (stickyDecreaseBtn) {
    stickyDecreaseBtn.addEventListener('click', function() {
      const currentValue = parseInt(stickyQuantityInput.value) || 1;
      if (currentValue > 1) {
        updateStickyQuantity(currentValue - 1);
      }
    });
  }

  if (stickyQuantityInput) {
    stickyQuantityInput.addEventListener('change', function() {
      updateStickyQuantity(this.value);
    });
  }

  // Sync from original to sticky when original changes
  if (originalQuantityInput) {
    originalQuantityInput.addEventListener('change', function() {
      syncQuantity(this, stickyQuantityInput);
      renderAddToCartButtons();
    });
  }

  // Variant swaps bubble a change event from the form's [name="id"] input
  originalForm.addEventListener('change', function(e) {
    if (e.target.name === 'id') renderAddToCartButtons();
  });

  renderAddToCartButtons();

  // Sticky add to cart functionality
  if (stickyAddToCartBtn) {
    stickyAddToCartBtn.addEventListener('click', function() {
      // Sync quantities before submitting
      if (originalQuantityInput && stickyQuantityInput) {
        originalQuantityInput.value = stickyQuantityInput.value;
      }
      
      // Hide the sticky island since cart drawer will open
      hideStickyIslandForCartDrawer();
      
      // Trigger the original add to cart button
      if (originalAddToCartBtn) {
        originalAddToCartBtn.click();
      }
    });
  }

  // Show/hide sticky island based on scroll position
  function toggleStickyIsland() {
    if (!originalAddToCartBtn) return;

    const originalRect = originalAddToCartBtn.getBoundingClientRect();
    const isOriginalVisible = originalRect.top >= 0 && originalRect.bottom <= window.innerHeight;
    
    if (isOriginalVisible) {
      stickyCartIsland.classList.remove('visible');
    } else {
      // Only show if cart drawer is not open
      const cartDrawer = document.querySelector('cart-drawer');
      const isCartDrawerOpen = cartDrawer && cartDrawer.classList.contains('is-visible');
      
      if (!isCartDrawerOpen) {
        stickyCartIsland.classList.add('visible');
      }
    }
  }

  // Cart Drawer Integration
  function setupCartDrawerIntegration() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    
    // Create observer to watch for class changes on cart-drawer
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          
          // Check if cart drawer is now visible
          if (target.classList.contains('is-visible')) {
            hideStickyIslandForCartDrawer();
          } else {
            showStickyIslandFromCartDrawer();
          }
        }
      });
    });
    
    // Observer for class changes

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    const originalOpen = cartDrawer.open;
    const originalClose = cartDrawer.close;
    
    cartDrawer.open = function(...args) {
      hideStickyIslandForCartDrawer();
      return originalOpen.apply(this, args);
    };
    
    cartDrawer.close = function(...args) {
      const result = originalClose.apply(this, args);
      showStickyIslandFromCartDrawer();
      return result;
    };
  }


  const cartLink = document.querySelector('[data-cart-link]');
  if (cartLink) {
    cartLink.addEventListener('click', function() {
      hideStickyIslandForCartDrawer();
    });
  }

  document.addEventListener('submit', function(e) {
    if (e.target.matches('form[action*="/cart/add"]')) {
      hideStickyIslandForCartDrawer();
    }
  });


  document.addEventListener('keydown', function(e) {
    if (e.code.toUpperCase() === 'ESCAPE') {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && cartDrawer.classList.contains('is-visible')) {
    
        setTimeout(showStickyIslandFromCartDrawer, 100);
      }
    }
  });

  // Handle clicking on cart drawer overlay
  document.addEventListener('click', function(e) {
    if (e.target.id === 'CartDrawer-Overlay') {
      // Overlay click will close cart drawer, so show island after delay
      setTimeout(showStickyIslandFromCartDrawer, 100);
    }
  });

  // Listen for scroll events
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(toggleStickyIsland, 10);
  });

  // Listen for resize events
  window.addEventListener('resize', function() {
    toggleStickyIsland();
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (!isMobile() && cartDrawer && cartDrawer.classList.contains('is-visible')) {
      stickyCartIsland.classList.remove('visible');
    }
  });

  // Initial check
  setTimeout(toggleStickyIsland, 100);

  function updateStickyButtonState() {
    renderAddToCartButtons();
  }

  
  if (originalAddToCartBtn) {
    const observer = new MutationObserver(updateStickyButtonState);
    observer.observe(originalAddToCartBtn, { 
      attributes: true, 
      childList: true, 
      subtree: true,
      characterData: true
    });
    

    updateStickyButtonState();
  }
  setupCartDrawerIntegration();
});